import { Link } from "react-router-dom"
import { getUsers } from "../../api/axios"
import { useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import LoadingContainer from "../../components/LoadingContainer";

const UserTable = (props) => {

const [isLoading, setIsLoading] = useState(true);
const [users, setUsers] = useState([]);

// https://www.robinwieruch.de/react-hooks-fetch-data/

const { auth } = useAuth();

useEffect(() => {

  let isMounted = true;
  const controller = new AbortController();

  const fetchData = async () => {
      
    setIsLoading(true);
    
    try {
      
      const data = await getUsers({props, auth, signal: controller.signal});
      isMounted && setUsers(data.results);

    } catch (error) {

      setUsers(null);

    }

    setIsLoading(false);

  };

  fetchData();

  return () => { 
    isMounted = false;
    controller.abort();
  }
    
}, [props, auth]);

  

  const hasUsers = Array.isArray(users) && users.length > 0;

  return (

    <LoadingContainer isLoading={isLoading}>
          
      <table className="table table--enhanced">
                      
        <thead>
            <tr>
                <td>#</td> 
                <td>Nombre</td> 
                <td>Apellido</td> 
                <td>Email</td> 
                <td>Empresa</td> 
                <td>Perfil</td> 
            </tr>
        </thead>
        
        <tbody>
            {!isLoading && !hasUsers && (
              <tr><td colSpan="6" className="c loading">No se encontraron usuarios</td></tr>
            )}
            {!isLoading && hasUsers && users.map( item => (

              <tr key={item.id}>
                  
                  <td className="c">
                    <Link className="vinculo table-id-pill" to={`/users/edit/${item.id}`}>{item.id}</Link>
                  </td>
                  <td>
                    <span className="table-primary">{item.name}</span>
                  </td>
                  <td>
                    <span className="table-primary">{item.last_name}</span>
                  </td>
                  <td>
                    <span className="table-email">{item.email}</span>
                  </td>
                  <td>
                    <span className="table-secondary">{item.company}</span>
                  </td>
                  <td>
                    <span className="table-status table-status--neutral">{item.profile_name}</span>
                  </td>
              </tr>
            ))}
            
        </tbody>

      </table>
    </LoadingContainer>
    
    )
}

export default UserTable
